/**
 * Empty calendar prompt that opens the shared activity-creation chooser.
 *
 * @module apps/web/src/components/calendar/CalendarEmptyState
 */

import { Button } from '@/components/ui/button';
import { openNewActivityFlow } from '@/components/activities/NewActivityFlow';

/**
 * Empty calendar prompt that opens the shared activity-creation chooser.
 */
export function CalendarEmptyState() {
  return (
    <section className="calendar-empty-field">
      <span className="calendar-empty-mark" aria-hidden="true">
        —
      </span>
      <h2>A clear field</h2>
      <p>There are no Activities yet. Add one or speak a scheduling command to begin.</p>
      <Button onClick={() => openNewActivityFlow('choose')}>Add Activity</Button>
    </section>
  );
}
